import { render, staticRenderFns } from "./employeesWithdrawals.vue?vue&type=template&id=1f70fb5e"
import script from "./employeesWithdrawals.vue?vue&type=script&lang=js"
export * from "./employeesWithdrawals.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports